import { render } from "./UFloatingLabel.vue?vue&type=template&id=f8da6cae"
const script = {}
script.render = render

export default script